import { render } from "./LotteryEvent.vue?vue&type=template&id=0e092644&scoped=true&ts=true"
import script from "./LotteryEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LotteryEvent.vue?vue&type=script&setup=true&lang=ts"

import "./LotteryEvent.vue?vue&type=style&index=0&id=0e092644&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e092644"],['__file',"src/views/me/LotteryEvent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e092644"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e092644', __exports__)) {
    console.log('reload')
    api.reload('0e092644', __exports__)
  }
  
  module.hot.accept("./LotteryEvent.vue?vue&type=template&id=0e092644&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0e092644', render)
  })

}


export default __exports__